export default {
    order: {},
    productTemplates: [],
    deliveryFile: null,
    adviceNoteDraft: null,
    cancelToken: null
}
